<template>
  <t-layout key="mix" style="height: 100%;">
    <t-header><layout-header /></t-header>
    <t-layout>
      <t-aside v-if="!hideSidebar"><layout-sidebar /></t-aside>
      <t-content :class="{ 'full-screen': hideSidebar }">
        <router-view />
        <div class="footer-bottom-explain">
          Copyright @ 2022-{{ new Date().getFullYear() }} Tencent. All Rights
          Reserved
        </div>
      </t-content>
    </t-layout>
  </t-layout>
</template>

<script lang="ts">
import Vue from 'vue';
import LayoutHeader from './components/LayoutHeader.vue';
import LayoutSidebar from './components/LayoutSidebar.vue';

import '@/styles/layout.less';


export default Vue.extend({
  name: 'base-layout',
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      hideSidebar: false
    }
  },
  created() {
    const pathList = ['register', 'login', 'act/init', 'act/recharge', 'act/auth'];
    this.hideSidebar = pathList.some(item => this.$route.path.includes(item));
    // 路径是 act/add 不带参数的是 新建，也需要全屏
    if(this.$route.path == '/act/add' && !this.$route.query?.actno) this.hideSidebar = true
  }
});
</script>

<style lang="less" scoped>
.footer-bottom-explain {
  position: relative;
  // bottom: 10px;
  width: 100%;
  // height: 50px;
  margin: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
  // background-color: #fff;
  font-size: 12px;
  font-weight: 400;
}

/deep/.t-layout__content {
  margin: 24px 24px 0px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.full-screen {
  margin: 0;
}
</style>
